import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import I18n from 'I18n';

// @ts-expect-error untyped import
import FilterOperatorRefinableInput from 'customer-data-filters/components/operator/FilterOperatorRefinableInput';
import FilterOperatorErrorRecord from 'customer-data-filters/filterQueryFormat/FilterOperatorErrorRecord';
import { getOperatorLabel, getPlaceholder, getPropertyFieldDefinitions
// @ts-expect-error untyped import
} from 'reporting-snowflake/relational/modify/filters/xo-filter-utils';
// @ts-expect-error untyped import
import { selectAllGates } from 'dashboard-lib/public/userInfo';
import { getInputComponentListMembership, getOperatorsListMembership, getMappedPropsListMembership } from 'platform-dashboard-ui/filter/utils/listMembershipFilterUtils';
import { getIsUngated } from '../../../../../lib/dashboardFilters/getDashboardFilterOperators';
import { REPORTING_LEGACY_OPERATOR_USAGE } from '../../../../../constants/Metrics';
import { Metrics } from '../../../../../lib/Metrics';
import { View } from 'foundations-components/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
const NO_ERROR = FilterOperatorErrorRecord({
  error: false
});
export const ListMembershipOperatorInput = ({
  dataSource,
  property,
  selectedOperator,
  onChange,
  resolvers
}) => {
  const gates = useSelector(selectAllGates);
  useEffect(() => {
    Metrics.counter(REPORTING_LEGACY_OPERATOR_USAGE, {
      type: 'list-membership'
    }).increment();
  }, []);
  return /*#__PURE__*/_jsx(View, {
    marginBlockStart: "300",
    children: /*#__PURE__*/_jsx(FilterOperatorRefinableInput, Object.assign({
      error: NO_ERROR,
      fieldDefinitions: getPropertyFieldDefinitions(),
      getDefaultTimezone: () => I18n.moment.portalTz().tz(),
      getFilterFamilyObjectName: () => '',
      getInputComponent: getInputComponentListMembership,
      getIsUngated: getIsUngated(gates),
      getObjectPropertyLabel: () => '',
      getOperatorLabel: getOperatorLabel,
      getOperators: getOperatorsListMembership,
      getPlaceholder: () => getPlaceholder(selectedOperator),
      isFiscalYearEnabled: true,
      isNotUsingTimePoints: true,
      isRollingDateOffsetInputEnabled: false,
      onChange: onChange,
      showIncludeUnknownValues: false,
      value: selectedOperator
    }, getMappedPropsListMembership({
      dataSource,
      property,
      resolvers
    })))
  });
};